/*
 * @Description:
 * @version:
 * @Author: guanbw_sr
 * @Date: 2023-08-18 08:39:16
 * @LastEditors: guanbowen 
 * @LastEditTime: 2023-08-18 10:41:34
 */
const parentRouter = [
  {
    label: '工作台',
    path: ''
  }
]
const routes = [
  {
    path: '/staging',
    name: 'staging',
    meta: {
      title: '工作台',
      icon: 'icon-guanyu',
      noAuth: true,
      parentTitle: parentRouter
    },
    component: () => import('@main/modules/work/views/staging.vue')
  },
  {
    path: '/pendingCenter',
    name: 'pendingCenter',
    meta: {
      title: '待办中心',
      icon: 'icon-guanyu',
      noAuth: true
    },
    component: () => import('@main/modules/work/views/pendingCenter.vue')
  },
  {
    path: '/messageCenter',
    name: 'messageCenter',
    meta: {
      title: '消息中心',
      icon: 'icon-guanyu',
      noAuth: true
    },
    component: () => import('@main/modules/work/views/messageCenter.vue')
  },
  {
    path: '/dataChange',
    name: 'dataChange',
    meta: {
      title: '账号资料变更',
      icon: 'icon-guanyu',
      noAuth: true
    },
    component: () => import('@main/modules/work/views/dataChange.vue')
  },
  {
    path: '/info',
    name: 'info',
    meta: {
      title: '供应商信息查看',
      icon: 'icon-guanyu',
      noAuth: true
    },
    component: () => import('@main/modules/work/views/info.vue')
  },
]
export default routes
